import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'

import { Operator } from '../operator'

export class Equal extends Operator {
  constructor() {
    super(LOGIC_OPERATOR.EQUAL)
  }

  evaluate(factValue: unknown, comparisonValue: ComparisonValue): boolean {
    if (factValue instanceof Date) {
      return factValue.toISOString() === comparisonValue
    }

    // if we're comparing numbers to strings, then we normalize first
    if (
      (typeof factValue === 'string' && typeof comparisonValue === 'number') ||
      (typeof factValue === 'number' && typeof comparisonValue === 'string')
    ) {
      return Number(factValue) === Number(comparisonValue)
    }

    // in case of comparing arrays (i.e. multi-select matches exactly A, B)
    if (Array.isArray(factValue) && Array.isArray(comparisonValue)) {
      // fail early in case length is different
      if (factValue.length !== comparisonValue.length) return false

      const sortedFactValue = structuredClone(factValue).sort()
      const sortedComparisonValue = structuredClone(comparisonValue).sort()

      return sortedFactValue.every(
        (v, index) => v === sortedComparisonValue[index]
      )
    }

    return factValue === comparisonValue
  }
}
